import Navbar from "@/components/Navbar";
import { Link } from "react-router-dom";
import { ShieldCheck } from "lucide-react";

const TeacherTerms = () => (
  <div className="min-h-screen bg-mm-parchment bg-topo">
    <Navbar />
    <div className="container mx-auto py-10 max-w-3xl prose">
      <div className="text-xs uppercase tracking-[0.22em] font-bold text-mm-steel">Legal · Teachers</div>
      <h1 className="font-heading text-4xl font-black text-mm-navy mt-2">Teacher Terms of Service</h1>

      <div className="mt-6 rounded-xl border-2 border-mm-steel/25 bg-white p-5 flex items-start gap-3" data-testid="teacher-terms-privacy">
        <ShieldCheck size={20} strokeWidth={2.5} className="text-mm-gold mt-0.5" />
        <div className="text-sm text-mm-navy/90">
          <b>Anonymous student accounts.</b> These accounts are fully anonymous. No student personal data is collected or stored.
          Every classroom seat is a randomly-generated username plus a 4-digit PIN, with zero name, email, age, grade level, or
          location captured on the student record. Interest-quiz answers are stored only as preference data and cannot be traced
          back to a real student.
        </div>
      </div>

      <div className="mt-8 space-y-6 text-mm-navy/90 leading-relaxed">
        <section>
          <h2 className="font-heading text-xl font-black text-mm-navy">1. Teacher account</h2>
          <p className="text-sm">By creating a teacher account you confirm you are an educator, tutor, or homeschool guide 18+.
            You are responsible for how you distribute usernames and PINs to your students, and for any nicknames you attach to
            slots for your own reference (never shared with students).</p>
        </section>
        <section>
          <h2 className="font-heading text-xl font-black text-mm-navy">2. Free and Premium tiers</h2>
          <p className="text-sm">Free teacher accounts include 30 anonymous student slots total. Teacher Premium is
            <b> $100 per school year</b> (12 months from purchase) and enables unlimited classes and unlimited anonymous
            slots per teacher account. Renew annually to keep classroom access.</p>
        </section>
        <section>
          <h2 className="font-heading text-xl font-black text-mm-navy">3. Student data & privacy</h2>
          <p className="text-sm">We do not collect or store personally identifiable information (PII) for anonymous student
            accounts. Interest-quiz answers ("favorite subject", "dream career", etc.) are treated as content-personalization
            preferences and are not linked to any real-world identity. Teachers must not enter PII into slot nicknames — use
            classroom seat references only (e.g. "Row 2 Seat 4"). Mind Map staff will never ask for individual student data.</p>
        </section>
        <section>
          <h2 className="font-heading text-xl font-black text-mm-navy">4. Content safety</h2>
          <p className="text-sm">All AI-generated expedition content is filtered for age-appropriateness. Teachers may report any
            piece of content from within an expedition; those reports are routed to Mind Map staff for review.</p>
        </section>
        <section>
          <h2 className="font-heading text-xl font-black text-mm-navy">5. Acceptable use</h2>
          <p className="text-sm">Teachers agree not to use anonymous accounts to bypass age-appropriate content rules, share
            credentials outside of an active classroom, or resell access.</p>
        </section>
        <section>
          <h2 className="font-heading text-xl font-black text-mm-navy">6. Contact & questions</h2>
          <p className="text-sm">Reach us at <a className="underline font-bold" href="mailto:hello@themeadowsmindset.com">hello@themeadowsmindset.com</a>.
            See the general <Link to="/terms" className="underline font-bold">Terms</Link> and <Link to="/privacy" className="underline font-bold">Privacy Policy</Link> for anything not covered here.</p>
        </section>
      </div>
    </div>
  </div>
);

export default TeacherTerms;
